import{effect as t}from"@preact/signals-core";
/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function e(e){return class extends e{performUpdate(){var e;if(!1===this.isUpdatePending)return;null===(e=this._$Oo)||void 0===e||e.call(this);let s=!0;this._$Oo=t((()=>{s?(s=!1,super.performUpdate()):this.requestUpdate()}))}connectedCallback(){super.connectedCallback(),this.requestUpdate()}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Oo)||void 0===t||t.call(this)}}}export{e as SignalWatcher};
//# sourceMappingURL=signal-watcher.js.map
